import { Skeleton, tableHelpers } from '@round/creatorbase-ui';
import { getMeta, CellContext } from '../../helpers';
import styles from './ResponseRateCell.module.css';
import cn from 'classnames';

export const ResponseRateCell = ({ row: { original }, table }: CellContext) => {
    const { isLoading } = getMeta(table);
    const isBaseLoading = tableHelpers.isLoadingRow(original) || isLoading;

    if (isBaseLoading) {
        return <Skeleton className={styles.skeleton} />;
    }

    return <ResponseRate rate={original.metrics?.response_rate} />;
};

type ResponseRateProps = {
    rate: number | null | undefined;
};

/** Shared by the cell and the expanded row's details panel, so the rate is graded the same in both. */
export const ResponseRate = ({ rate }: ResponseRateProps) => {
    if (rate == null || typeof rate !== 'number') {
        return <span className={styles.muted}>-</span>;
    }

    const percentage = Math.round(rate * 100);

    return (
        <span
            className={cn(styles.value, {
                [styles.high]: percentage >= 90,
                [styles.medium]: percentage >= 70,
                [styles.low]: percentage < 70,
            })}
        >
            {percentage}%
        </span>
    );
};
